<template>
  <b-form class="docs-custom-send-form" ref="form">
    <div class="row">
      <div class="col-md-12">
        <b-form-group label="Адреc электронной почты" label-for="emails" class="is-required">
        <tags-input
          placeholder="E-mail адрес"
          element-id="tags"
          v-model="form.emails"
          :existing-tags="form.emails"
          :typeahead="true"
        ></tags-input>
        </b-form-group>
          <b-form-checkbox
          v-model="form.extra"
          :value="true"
          :unchecked-value="false"
        >
          Дополнительно
        </b-form-checkbox>
        <b-collapse id="collapse-extra" v-model="form.extra">
          <fieldset class="mt-2">
            <b-form-group id="amount" label="Сумма" label-for="amount" class="is-required w-auto">
              <b-form-input id="amount" v-model.trim="form.amount"></b-form-input>
            </b-form-group>
            <ul class="form-group">
              <li class="row" v-for="(member, key) in form.members" :key="key">
                <div class="col-md-3"><b-form-input v-model.trim="member.last_name" placeholder="Фамилия"></b-form-input></div>
                <div class="col-md-3"><b-form-input v-model.trim="member.first_name" placeholder="Имя"></b-form-input></div>
                <div class="col-md-3"><b-form-input v-model.trim="member.middle_name" placeholder="Отчество"></b-form-input></div>
                <div class="col-md-3 actions">
									<b-form-select v-model="member.packet_type" :options="packageTypes"></b-form-select>
									<b-button variant="danger" class="ml-2" @click="onRemoveItem(key)"><i class="fa fa-trash"></i></b-button>
								</div>
              </li>
            </ul>
							<b-button variant="primary" @click="onAddItem"><i class="fa fa-plus"></i></b-button>
          </fieldset>
        </b-collapse>
      </div>
    </div>
  </b-form>
</template>
<script>
import VoerroTagsInput from '@voerro/vue-tagsinput'
import '@voerro/vue-tagsinput/dist/style.css'
export default {
	components: {
		'tags-input': VoerroTagsInput
	},
	data () {
		return {
			form: {
				extra: false,
				amount: null,
				emails: [],
				members: []
			},
			packageTypes: [
				{value: 1, text: 'Стандарт'},
				{value: 2, text: 'Бизнес'},
				{value: 3, text: 'Вип'}
			]
		}
	},
	props: {
		amount: {
			type: Number,
			default: null
		},
		emails: {
			type: Array,
			default: () => {
				return []
			}
		},
		members: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	created () {
		this.form.amount = this.amount
		this.form.emails = this.emails
		this.form.members = [...this.members]
	},
	methods: {
		getData () {
			if (this.form.emails.length === 0) {
				this.$notify({
					group: 'default',
					type: 'danger',
					title: 'Необходимо ввсести email-адрес!',
					text: 'Укажите хотя бы один адрес электронной почты.<br>После ввода не забудьте нажать "Enter"'
				})
				return false
			}
			return this.form
		},
		checkRows () {
			let lastRow = this.form.members[this.form.members.length - 1]
			if (lastRow.first_name !== '' && lastRow.last_name !== '' && lastRow.middle_name !== '' && lastRow.packet_type > 0) {
				this.form.members.push({
					first_name: '',
					last_name: '',
					middle_name: '',
					packet_type: 0
				})
			}
		},
		onAddItem () {
			this.form.members.push({
				first_name: '',
				last_name: '',
				middle_name: '',
				packet_type: 0
			})
		},
		onRemoveItem (index) {
			if (this.form.members.length > 0) {
				this.form.members.splice(index, 1)
			}
		}
	}
}
</script>
<style lang="scss">
.docs-custom-send-form {
	.row {
		margin-left: -5px;
		margin-right: -5px;
		.col-md-3 {
			padding-left: 5px;
			padding-right: 5px;
		}
	}
	ul {
		padding: 0;
		li {
			margin-bottom: 1rem;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
	.actions {
		display: flex;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/payment/docs/custom-send-form.vue